<template>
    <div class="news" :style="'height:'+innerHeight+'px'">
        <div class="table">
            <div class="tab-li" @click="bindType" data-current="0">
                <div class="tab-li-ic">
                    <span class="iconfont iconkecheng2" style="background-color:#02c380">
                        <badge_dot :is_show="!params.message_notice"></badge_dot>
                    </span>
                </div>
                <div :class="'tab-li-txt '+(currentTypeTab==0?'curr':'')">课程</div>
            </div>
            <div class="tab-li" @click="bindType" data-current="1">
                <div class="tab-li-ic">
                    <span class="iconfont iconzuoye" style="background-color:#029ef1">
                        <badge_dot :is_show="!params.message_work"></badge_dot>
                    </span>
                </div>
                <div :class="'tab-li-txt '+(currentTypeTab==1?'curr':'')">作业</div>
            </div>
            <div class="tab-li" @click="bindType" data-current="2">
                <div class="tab-li-ic">
                    <span class="iconfont iconpinglun" style="background-color:#6782e9">
                        <badge_dot :is_show="!params.message_reply"></badge_dot>
                    </span>
                </div>
                <div :class="'tab-li-txt '+(currentTypeTab==2?'curr':'')">评论</div>
            </div>
            <div class="tab-li" @click="bindType" data-current="3">
                <div class="tab-li-ic">
                    <span class="iconfont icondianzan" style="background-color:#ff5959">
                        <badge_dot :is_show="!params.message_favor"></badge_dot>
                    </span>
                </div>
                <div :class="'tab-li-txt '+(currentTypeTab==3?'curr':'')">点赞</div>
            </div>
        </div>
        <van-swipe class="table-content"
                   :initial-swipe="currentTypeTab"
                   :loop="false"
                   :show-indicators="false"
                   @change="swiperChange">
            <!--课程-->
            <van-swipe-item>
                <div style="height:100%;overflow-y: auto">
                    <van-list
                            v-model="course_loading"
                            :finished="is_course_show"
                            finished-text="暂无更多记录"
                            :immediate-check="false"
                            offset="50"
                            @load="getCourseList"
                            v-if="course_list.length>0"
                    >
                    <div class="course" v-for="(item,index) in course_list" :key="index"
                          :data-message_id="item.message_id"
                          :data-index="index"
                          @click="bindGoToCurriculum">
                        <div class="course-info">
                            <span class="course-desc">
                                【{{item.datas.desc}}】
                                <badge_dot :is_show="item.status" badge-class="badge-class"></badge_dot>
                            </span>
                            <span class="course-sections-name">{{item.datas.sections_name}}</span>
                        </div>
                        <div class="course-detail">
                            <span class="course-name">{{item.datas.name}}</span>
                            {{item.datas.event_time_man}}
                        </div>
                    </div>

                    </van-list>

                    <van-empty description="暂无更多记录" v-if="course_list.length == 0"/>
                </div>

            </van-swipe-item>
            <!--作业-->
            <van-swipe-item>
                <div style="height:100%;overflow-y: auto">

                    <van-list
                            v-model="work_loading"
                            :finished="is_work_show"
                            finished-text="暂无更多记录"
                            :immediate-check="false"
                            offset="50"
                            @load="getWorkList"
                            v-if="work_list.length>0"
                    >
                    <div class="course" v-for="(item,index) in work_list" :key="index"
                          :data-message_id="item.message_id"
                          :data-index="index"
                          @click="bindGoToCurriculum">
                        <div class="course-info">
                            <span class="course-desc">
                                【{{item.datas.desc}}】
                                <badge_dot :is_show="item.status" badge-class="badge-class"></badge_dot>
                            </span>
                            <span class="course-sections-name">{{item.datas.name}}</span>
                        </div>
                        <div class="course-detail">
                            <span class="course-name">{{item.datas.course_name}}</span>
                            {{item.datas.event_time_man}}
                        </div>
                    </div>
                    </van-list>

                    <van-empty description="暂无更多记录" v-if="work_list.length == 0"/>
                </div>
            </van-swipe-item>
            <!--评论-->
            <van-swipe-item>
                <div style="height:100%;overflow-y: auto">

                    <van-list
                            v-model="comment_loading"
                            :finished="is_comment_show"
                            finished-text="暂无更多记录"
                            :immediate-check="false"
                            offset="50"
                            @load="getCommentList"
                            v-if="comment_list.length>0"
                    >
                    <div class="like" v-for="(item,index) in comment_list" :key="index"
                          :data-message_id="item.message_id"
                          :data-index="index"
                          @click="bindGoToCommentDetail">
                        <div class="like-user-image">
                            <img :src="item.datas.user_phone"/>
                            <badge_dot :is_show="item.status"></badge_dot>
                        </div>
                        <div class="like-user">
                            <div class="like-user-info">
                                <span class="like-user-name">{{item.datas.user_name}}</span>
                                {{item.datas.desc}}
                            </div>
                            <div class="like-user-content">
                                {{item.datas.reply_content}}
                            </div>
                            <div class="like-user-course">
                                <span>{{item.datas.course_name}}</span>
                                {{item.datas.event_time_man}}
                            </div>
                        </div>
                        <div class="like-user-work">
                            <div style="display: table;text-align:center">
                                <div class="work-content">
                                    <span v-if="item.datas.content.length>=15">{{item.datas.content.substring(0,14)+'...'}}</span>
                                    <span v-else>{{item.datas.content}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>

                    <van-empty description="暂无更多记录" v-if="comment_list.length == 0"/>
                </div>
            </van-swipe-item>
            <!--点赞-->
            <van-swipe-item>
                <div style="height:100%;overflow-y: auto">
                    <van-list
                            v-model="like_loading"
                            :finished="is_like_show"
                            finished-text="暂无更多记录"
                            :immediate-check="false"
                            offset="50"
                            @load="getLikeList"
                            v-if="like_list.length>0"
                    >

                    <div class="like" v-for="(item,index) in like_list" :key="index"
                          :data-message_id="item.message_id"
                          :data-index="index"
                          @click="bindGoToCommentDetail">
                        <div class="like-user-image">
                            <img :src="item.datas.user_phone"/>
                            <badge_dot :is_show="item.status"></badge_dot>
                        </div>
                        <div class="like-user">
                            <div class="like-user-info">
                                <span class="like-user-name">{{item.datas.user_name}}</span>
                                {{item.datas.desc}}
                            </div>
                            <div class="like-user-content" style="margin:0">
                            </div>
                            <div class="like-user-course">
                                <span>{{item.datas.course_name}}</span>
                                {{item.datas.event_time_man}}
                            </div>
                        </div>
                        <div class="like-user-work">
                            <div style="display: table;text-align:center">
                                <div class="work-content">
                                    <span v-if="item.datas.content.length>=15">{{item.datas.content.substring(0,14)+'...'}}</span>
                                    <span v-else>{{item.datas.content}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>

                    <van-empty description="暂无更多记录" v-if="like_list.length == 0"/>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
    import {Swipe, SwipeItem,List,Empty} from 'vant';
    import badge_dot from '../../components/common/badge_dot';
    export default {
        name: "index",
        components:{
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [List.name]:List,
            [Empty.name]:Empty,
            badge_dot
        },
        data(){
            return {
                currentTypeTab:0,
                pageSize:10,
                params:{},
                innerHeight:0,

                //课程
                course_list:[],
                course_total:0,
                course_page:1,
                course_loading:false,
                is_course_show:false,

                //作业
                work_list:[],
                work_total:0,
                work_page:1,
                work_loading:false,
                is_work_show:false,

                //评论
                comment_list:[],
                comment_total:0,
                comment_page:1,
                comment_loading:false,
                is_comment_show:false,

                //点赞
                like_list:[],
                like_total:0,
                like_page:1,
                like_loading:false,
                is_like_show:false,
            }
        },
        mounted() {
            this.innerHeight=window.innerHeight;
            this.util.hideOptionMenu();
            this.bindSwitch();
        },
        activated(){
            this.getHasUnread();
        },
        methods:{
            getHasUnread(){
                var _self=this;
                this.util.server.mini_message.has_unread({
                    is_show_load:false,
                    callback:function (res) {
                        _self.params=res.data;
                    }
                })
            },
            bindGoToCurriculum(e){
                var _self=this;
                var index = e.currentTarget.dataset.index;
                var message_id = e.currentTarget.dataset.message_id;
                var list = [];

                if(this.currentTypeTab == 0){
                    list = this.course_list;
                }else if(this.currentTypeTab == 1){
                    list = this.work_list;
                }

                if(list[index].status==0){
                    this.util.server.mini_message.read_message({
                        data:{
                            message_id:message_id
                        },
                        is_show_load: false,
                        callback:function (res) {
                            if(res.code == 1){

                                if(_self.currentTypeTab == 0){
                                    _self.course_list[index].status=1;
                                }else if(_self.currentTypeTab == 1){
                                    _self.work_list[index].status=1;
                                }
                            }
                        }
                    })
                }

                if(this.currentTypeTab == 0){
                    this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+list[index].datas.course_id+'&current='+list[index].datas.sections_id+'&token='+this.util.token)
                }else if(this.currentTypeTab == 1){
                    this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+list[index].datas.course_id+'&work_busy_id='+list[index].datas.work_busy_id+'&token='+this.util.token)
                }

            },
            bindGoToCommentDetail(e){
                var _self=this;
                var index = e.currentTarget.dataset.index;
                var message_id = e.currentTarget.dataset.message_id;
                var list = [];

                if(this.currentTypeTab == 2){
                    list = this.comment_list;
                }else if(this.currentTypeTab == 3){
                    list = this.like_list;
                }
                console.log("bindGoToCommentDetail")
                
                if(list[index].status==0){
                    this.util.server.mini_message.read_message({
                        data:{
                            message_id:message_id
                        },
                        is_show_load: false,
                        callback:function (res) {
                            if(res.code == 1){
                                if(_self.currentTypeTab == 2){
                                    _self.comment_list[index].status=1;
                                }else if(_self.currentTypeTab == 3){
                                    _self.like_list[index].status=1;
                                }
                            }
                        }
                    })
                }
                

                this.$router.push(this.util.urlPrefix+'/course_task/comment_detail?work_answer_id='+list[index].datas.work_answer_id+'&work_busy_id='+list[index].datas.work_busy_id+'&token='+this.util.token)

            },
            //切换
            bindType(e){
                this.currentTypeTab = e.currentTarget.dataset.current *1 ;
                this.bindSwitch();
            },
            swiperChange(index){
                this.currentTypeTab =index;
                this.bindSwitch();
            },
            bindSwitch(){
                switch (this.currentTypeTab) {
                    case 0: // 课程
                        if(this.course_list.length == 0){
                            this.getCourseList(1);
                        }
                        break;
                    case 1: // 作业
                        if(this.work_list.length == 0){
                            this.getWorkList(1);
                        }
                        break;
                    case 2: // 评论
                        if(this.comment_list.length == 0){
                            this.getCommentList(1);
                        }
                        break;
                    case 3: // 点赞
                        if(this.like_list.length == 0){
                            this.getLikeList(1);
                        }
                        break;
                }
            },
            //课程列表
            getCourseList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.course_page;
                    pageNo +=1;

                    this.course_page=pageNo;

                }else{

                    this.course_page=page;

                }

                this.util.server.mini_message.list({
                    data:{
                        message_type:1,
                        page:this.course_page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        _self.course_loading = false;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.course_total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.course_list=data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.course_list = this.course_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_course_show=false;
                                //判断是否存在下一页
                                if(this.course_total*1 == this.course_list.length){

                                    this.is_course_show=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.course_list=[];
                                    this.is_course_show=false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //作业列表
            getWorkList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.work_page;
                    pageNo +=1;

                    this.work_page=pageNo;

                }else{

                    this.work_page=page;

                }

                this.util.server.mini_message.list({
                    data:{
                        message_type:2,
                        page:this.work_page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        _self.work_loading = false;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.work_total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.work_list = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.work_list = this.work_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_work_show = false;
                                //判断是否存在下一页
                                if(this.work_total*1 == this.work_list.length){
                                    this.is_work_show = true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.work_list = [];
                                    this.is_work_show = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //评论列表
            getCommentList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.comment_page;
                    pageNo +=1;

                    this.comment_page=pageNo;

                }else{

                    this.comment_page=page;

                }

                this.util.server.mini_message.list({
                    data:{
                        message_type:3,
                        page:this.comment_page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        this.comment_loading = false;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.comment_total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.comment_list = data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.comment_list = this.comment_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_comment_show = false;
                                //判断是否存在下一页
                                if(this.comment_total*1 == this.comment_list.length){
                                    this.is_comment_show = true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.comment_list = [];
                                    this.is_comment_show = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //点赞列表
            getLikeList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.like_page;
                    pageNo +=1;

                    this.like_page=pageNo;

                }else{

                    this.like_page=page;

                }
                
                this.util.server.mini_message.list({
                    data:{
                        message_type:4,
                        page:this.like_page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        this.like_loading = false;
                        
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.like_total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.like_list = data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.like_list = this.like_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_like_show = false;
                                //判断是否存在下一页
                                if(this.like_total*1 == this.like_list.length){
                                    this.is_like_show = true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.like_list = [];
                                    this.is_like_show = false;
                                }
                            }
                            console.log("11111111111",this.like_list)
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        },
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .news{
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .table{
        background-color: #ffffff;
        display: flex;
        padding: 20px 0;
    }
    .table .tab-li{
        flex: 1;
        text-align: center;
    }
    .tab-li-ic{
        padding: 10px 0;
    }
    .tab-li-ic .iconfont{
        color: #fff;
        padding: 10px;
        font-size: 18px;
        border-radius: 5px;
        position: relative;
    }
    .tab-li-txt{
        margin-top: 5px;
        color: #999999;
    }
    .tab-li-txt.curr{
        color: #ff6600;
    }
    .table-content{
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 100%;
    }
    .no-list{
        text-align: center;
        width: 100%;
        margin: 10px 0;
        color: #999;
        font-size: 12px;
    }
    .like{
        padding: 15px 10px;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        margin: 10px;
        box-shadow: 1px 0 10px #eee;
    }
    .like-user-image{
        width: 40px;
        position: absolute;
        font-size: 0;
    }
    .like-user-image img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .like-user{
        padding-left: 50px;
        padding-right: 70px;
    }
    .like-user-info{
        color: #999;
    }
    .like-user-name{
        color: #576b95;
    }
    .like-user-content{
        line-height: 20px;
        margin: 10px 0;
        min-height: 20px;
    }
    .like-user-course{
        font-size: 12px;
        color: #999;
        display: flex;
    }
    .like-user-course span{
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
    }
    .like-user-work{
        position: absolute;
        width: 55px;
        font-size: 10px;
        height: 45px;
        top: 20px;
        right: 15px;
        overflow: hidden;
        color: #999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .work-content{
        display: table-cell;
        vertical-align: middle;
        font-size: 10px;
        color: #999;
        height: 45px;
        width: 55px;
    }
    .course{
        padding: 15px 10px;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        margin: 10px;
        box-shadow: 1px 0 10px #eee;
    }
    .course-info .course-desc{
        color: #576b95;
        position: relative;
    }
    .course-info .course-sections-name{
        font-weight: bold;
    }
    .course-detail{
        font-size: 12px;
        color: #999;
        display: flex;
        margin-top: 10px;
    }
    .course-detail .course-name{
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
    }
</style>
